import { episodeOfCareAction } from '../../actions/constant';

const {
  GET_SINGLE_EPISODE_OF_CARE_FAILURE,
  GET_SINGLE_EPISODE_OF_CARE_SUCCESS,
  GET_SINGLE_EPISODE_OF_CARE_LOADING,
} = episodeOfCareAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getSingleEpisodeOfCare = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SINGLE_EPISODE_OF_CARE_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_SINGLE_EPISODE_OF_CARE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_SINGLE_EPISODE_OF_CARE_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
